const API_STORAGE_CREATE = '/storage-create'
const API_STORAGE_UPDATE = '/storage-update'
const API_STORAGE_DETAIL = '/storage-detail'
const API_STORAGE_RECREATE = '/storage-re-create'
const API_STORAGE_IMPORT = '/storage-import'
const API_STORAGE_SUCCESS = '/storage-success'
const API_STORAGE_CANCEL = '/storage-cancel'
const API_STORAGE_CHECKIN = '/inventory-checkin'
const API_SWITCH_STORAGE_CREATE = '/storage-switch/create'
const API_SWITCH_STORAGE_EDIT = '/storage-switch/edit'
const API_SWITCH_STORAGE_DETAIL = '/storage-switch/detail'
const API_EXPORT_STORAGE_DETAIL = '/storage-export/detail'
const API_IMPORT_STORAGE_DETAIL = '/storage-import/detail'
const API_BARCODE_PRINT = '/barcode'
const API_SWITCH_LIST = '/inventory-trans'
const LOGIN_LINK = `${process.env.VUE_APP_LOGIN}/login?appId=5efef20c4521fd3aaabf4197&redirectUri=${encodeURIComponent(process.env.VUE_APP_REDIRECT_URL)}`

export { API_STORAGE_CREATE, API_STORAGE_UPDATE, API_STORAGE_IMPORT, API_STORAGE_SUCCESS, API_STORAGE_DETAIL, API_STORAGE_CANCEL, API_STORAGE_CHECKIN, API_STORAGE_RECREATE,
  API_SWITCH_STORAGE_CREATE, API_SWITCH_STORAGE_EDIT, API_SWITCH_STORAGE_DETAIL, API_BARCODE_PRINT, API_SWITCH_LIST, API_EXPORT_STORAGE_DETAIL, API_IMPORT_STORAGE_DETAIL, LOGIN_LINK
}

